import { styled } from '@mend/mui';
import { Link } from '@mui/material';

import logoUrl from '#assets/logo-48.png';
import {
  Description as StatusMessageDescription,
  Root as StatusMessageRoot,
} from '#components/StatusMessage.tsx';
import { config } from '#config.ts';

const Logo = styled('img')({ display: 'block' });

function PortalLink(props: { children: React.ReactNode }) {
  return (
    <Link href={config.PORTAL_BASE_URL} target="_blank">
      {props.children}
    </Link>
  );
}

export function Login() {
  return (
    <StatusMessageRoot
      title="Sign in required"
      description={
        <StatusMessageDescription>
          Please sign in to <PortalLink>Mend</PortalLink> to access Signal.
        </StatusMessageDescription>
      }
      icon={
        <PortalLink>
          <Logo src={logoUrl} alt="Mend" width={48} height={48} />
        </PortalLink>
      }
    />
  );
}
